<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16 7H11C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19H20V21H11C6.58172 21 3 17.4183 3 13C3 8.58172 6.58172 5 11 5H16V1L22 6L16 11V7Z"></path></svg>
</template>
